// Seeded category ids for the few places that must branch on a specific category. Branch on the
// id, never on the name: a category's name is display text and can change, its id cannot.
export const ELECTRICITY_CATEGORY_ID = 'df026bd9-281d-4013-80e4-a1ef92965502';
export const FUELS_CATEGORY_ID = 'f88cd55e-9e30-4605-8106-24a53e0b5f62';
// The transmission and distribution loss factors: grid electricity and district heat, and EV
// charging. Upstream rows on these are loss rows, not well-to-tank rows, and follow the
// organisation's losses setting rather than its well-to-tank setting (backend
// lib/upstream-policy/upstream-policy.js holds the same list).
export const GRID_AND_HEAT_LOSS_CATEGORY_ID = '8ca0d2ae-9941-44eb-81b3-6829e0e0f82d';
export const EV_CHARGING_LOSS_CATEGORY_ID = '4cb4ed81-6337-4ada-9dee-ebf9bbe8ca6c';
export const DISTRIBUTION_LOSS_CATEGORY_IDS: readonly string[] = [GRID_AND_HEAT_LOSS_CATEGORY_ID, EV_CHARGING_LOSS_CATEGORY_ID];
